import React, { useEffect, useState } from 'react';
import styles from './swipe-quota.module.scss';
import { Button, Typography } from '@/ui-kit';
import clsx from 'clsx';
import { routesApp } from '@/constans/routes';
import { addDays, differenceInHours, differenceInMinutes, isAfter, isBefore, sub } from 'date-fns';
import { callYaMetrika } from '@/utils/call-ya-metrika';
import { eventsApi } from '@/api';

interface Props {}

export const SwipeQuota: React.FC<Props> = () => {
    const [leftHours, setLeftHours] = useState('00')
    const calcLeftHours = () => {
        const today = new Date()
        const todayIn9 = new Date(
            today.getTime()
        )
        todayIn9.setHours(9)
        todayIn9.setMinutes(0)
        todayIn9.setSeconds(0)
        const todayIn21 = new Date(
            today.getTime()
        )
        todayIn21.setHours(21)
        todayIn21.setMinutes(0)
        todayIn21.setSeconds(0)
        const tomorrowIn9 =
            addDays(
                new Date(
                    todayIn9.getTime()
                ),
                1
            )
        if (isBefore(today, todayIn9)) {
            const diffBetweenNowAnd9Hours = differenceInMinutes(
                todayIn9,
                today
            )
            return diffBetweenNowAnd9Hours < 10 ?
                    `0${diffBetweenNowAnd9Hours}`
                :
                    diffBetweenNowAnd9Hours
        }
        if (isBefore(today, todayIn21)) {
            const diffBetweenNowAnd21Hours = differenceInHours(
                todayIn21,
                today
            )
            return diffBetweenNowAnd21Hours < 10 ?
                    `0${diffBetweenNowAnd21Hours}`
                :
                    diffBetweenNowAnd21Hours
        }
        if (isBefore(today, tomorrowIn9)) {
            const diffBetweenNowAnd9HoursOfTomorrow = differenceInHours(
                tomorrowIn9,
                today
            )
            return diffBetweenNowAnd9HoursOfTomorrow < 10 ?
                    `0${diffBetweenNowAnd9HoursOfTomorrow}`
                :
                    diffBetweenNowAnd9HoursOfTomorrow
        }
        return '00'
    }

    const [leftMins, setLeftMins] = useState('00')
    
    const calcLeftMins = () => {
        const today = new Date()
        const todayIn9 = new Date(
            today.getTime()
        )
        todayIn9.setHours(9)
        todayIn9.setMinutes(0)
        todayIn9.setSeconds(0)
        const todayIn21 = new Date(
            today.getTime()
        )
        todayIn21.setHours(21)
        todayIn21.setMinutes(0)
        todayIn21.setSeconds(0)
        const tomorrowIn9 =
            addDays(
                new Date(
                    todayIn9.getTime()
                ),
                1
            )
        if (isBefore(today, todayIn9)) {
            const diffBetweenNowAnd9Hours = differenceInMinutes(
                todayIn9,
                today
            )
            return (diffBetweenNowAnd9Hours - diffBetweenNowAnd9Hours / 60) < 10 ?
                    `0${diffBetweenNowAnd9Hours - diffBetweenNowAnd9Hours / 60}`
                :
                    diffBetweenNowAnd9Hours - diffBetweenNowAnd9Hours / 60
        }
        if (isBefore(today, todayIn21)) {
            const diffBetweenNowAnd21Hours = differenceInMinutes(
                todayIn21,
                today
            )
            return (diffBetweenNowAnd21Hours - 60 * Math.floor(diffBetweenNowAnd21Hours / 60)) < 10 ?
                    `0${diffBetweenNowAnd21Hours - 60 * Math.floor(diffBetweenNowAnd21Hours / 60)}`
                :
                    diffBetweenNowAnd21Hours - 60 * Math.floor(diffBetweenNowAnd21Hours / 60)
        }
        if (isBefore(today, tomorrowIn9)) {
            const diffBetweenNowAnd9HoursOfTomorrow = differenceInMinutes(
                tomorrowIn9,
                today
            )
            return (diffBetweenNowAnd9HoursOfTomorrow - 60 * Math.floor(diffBetweenNowAnd9HoursOfTomorrow / 60)) < 10 ?
                    `0${diffBetweenNowAnd9HoursOfTomorrow - 60 * Math.floor(diffBetweenNowAnd9HoursOfTomorrow / 60)}`
                :
                    diffBetweenNowAnd9HoursOfTomorrow - 60 * Math.floor(diffBetweenNowAnd9HoursOfTomorrow / 60)
        }
        return '00'
    }

    useEffect(() => {
        const interval = setInterval(() => {
            setLeftHours(
                calcLeftHours()
                    .toString()
            )
            setLeftMins(
                calcLeftMins()
                    .toString()
            )
        }, 1000)
        return () => clearInterval(interval)
    }, [])

    useEffect(() => {
        const event = 'swipe_quota_screen'
        callYaMetrika(event)
        eventsApi.updateUserEvent(event)
    }, [])

    return (
        <div className={styles.wrapper}>
            <div className={styles.timer}>
                <Typography
                    typeColor="white"
                    className={styles.timerText}
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    {
                        leftHours
                    }
                </Typography>
                <Typography
                    typeColor="white"
                    className={
                        clsx(
                            styles.timerText,
                            styles.timerSeparator
                        )
                    }
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    :
                </Typography>
                <Typography
                    typeColor="white"
                    className={styles.timerText}
                    fontFamily="SFProText"
                    center
                    fontWeight="semibold">
                    {
                        leftMins
                    }
                </Typography>
            </div>
            <div className={styles.container}>
                <Typography
                    fontWeight="semibold"
                    typeColor="white"
                    className={styles.title}
                    fontFamily="SFProText"
                    center>
                    Лимит просмотра анкет<br />исчерпан
                </Typography>
                <Typography
                    typeColor="white"
                    fontFamily="SFProText"
                    center
                    className={styles.text}
                    fontWeight="normal">
                    Завтра лента обновится и будут новые знакомства
                </Typography>
                <div className={styles.actions}>
                    <Button
                        className={
                            clsx(
                                styles.button,
                                styles.primaryBtn
                            )
                        }
                        textColor="black"
                        typeColor="white"
                        isLink
                        to={routesApp.liked}>
                        Смотреть лайки
                    </Button>
                    <Button
                        className={
                            clsx(
                                styles.button,
                                styles.secondaryBtn
                            )
                        }
                        textColor="black"
                        typeColor="white"
                        isLink
                        to={routesApp.messages}>
                        В чат
                    </Button>
                </div>
            </div>
        </div>
    );
};
